import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreBillingAgreementsModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { RemovePaymentMethodModalComponent } from './remove-payment-method-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreBillingAgreementsModule,
    UiModule,
    TrackingModule,
  ],
  declarations: [RemovePaymentMethodModalComponent],
})
export class RemovePaymentMethodModalModule {}
